export default "__VITE_ASSET__59269b75__"